<template>
    <section class="brandDetail">
        <header-com />

        <!---->
        <section class="banner t_center">
            <div class="mask">
                <img src="/images/base/logo2.png" class="animated fadeIn"  align="middle">
                <div class="whiteLine animated fadeIn"  ></div>
                <img src="/images/base/logo3.png" class="animated fadeIn"  align="middle">
            </div>
        </section>

        <!-- banner下信息列表 -->
        <ul class="bannerBot">
            <li v-for="item in bannerBotList" class="animated"  data-animation="show"  >
                <div class="blackLine " :style="{width:item.width}"></div>
                <h2 class="f24 bold" >{{item.title}}</h2>
            </li>
        </ul>

        <!--视频模块-->
        <section class="videoWrap">
            <video :src="videoSrc" ref="myVideo"></video>
            <div class="videoMask t_center" @click="playVideo">
                <div v-show="!isPlay" >
                </div>
            </div>

            <div class="t_center">
                <img class="arrow" src="/images/base/brandDetail_15.png" align="middle">
            </div>

            <ul class="videoBotList">
                <li v-for="item in videoBotList"  class="animated"  data-animation="show">
                    <h2 class="f24 bold">{{item.title}}</h2>
                    <p class="f14">{{item.desc}}</p>
                </li>
            </ul>
            <img src="/images/base/brandDetail_03.png" alt="" width="100%" align="middle">

            <ul class="list f13 ">
                <li v-for="item in list"  class="animated"  data-animation="show">
                    <p>{{item.desc1}}</p>
                    <h2 class="f24 bold">{{item.title}}</h2>
                    <p>{{item.desc2}}</p>
                </li>
            </ul>
        </section>

     
        <section class="about">
            <div class="aboutBanner">
                <img src="/images/base/brandDetail_04.png" alt="" width="100%" align="middle">
                <div class="mask">
                    <div >
                        <img src="/images/base/brandDetail_14.png" alt="">
                        <div class="whiteLine " ></div>
                        <p class="f14 bold" >累计服务1000+品牌<br/>分析处理5000个症状节点<br/>定制方案 不叠加收费<br/>原厂级清洁与颜料 安全环保</p>
                    </div>

                </div>
            </div>

            <img :src="'/images/base/'+nav[active].pic+'.png'" alt="" width="100%" align="middle">
            

            <van-tabs v-model="active" background="#f8f8f8" color="#7ADFDF" title-inactive-color="#999" title-active-color="#333" swipeable>
                <van-tab  v-for="(item,index) in nav" :title="item.title" :key='index'></van-tab>
            </van-tabs>

            <div class="content f14">
                {{nav[active].content}}
            </div>

            <div class="imgArr clearfix">
                <img src="/images/base/brandDetail_06.png" alt="" width="100%" align="middle">
                <img class="l" src="/images/base/brandDetail_07.png" alt="" align="middle">
                <img class="r" src="/images/base/brandDetail_08.png" alt="" align="middle">
            </div>
    

        </section>


        <!--底部-->
        <section class="bot t_center">
            <h2 class="f24 bold">包拯=互联网+手工艺</h2>
            <p class="f14">致力于通过互联网变革这个千年不变的传统行业，让手艺人能专注于提升自己的技术，让用户能够安心享用心爱之物的美好。</p>
        </section>
        <img src="/images/base/brandDetail_09.png" alt="" width="100%" align="middle">

    </section>
</template>

<script>
    import publicObj from '../../../assets/js/public'
    import wxShare from "@/assets/js/wx.share"

    export default {
        name: "index",
        data() {
            return {
                active : 0,
                videoSrc:'https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/video/bz_release_2020727134553.mp4',
                isPlay:false,
                bannerBotList:[
                    {title:'每一份热爱 包拯都懂得',width:'100px'},
                    {title:'用科技守住手工艺的灵魂',width:'200px'},
                    {title:'重新定义行业 你与物品的回忆',width:'250px'},
                ],
                videoBotList:[
                    {title:'匠人精神·重新定义',desc:'包拯现在已经有100多名匠人，依靠互联网和技术实现手工艺的规模化，把从前无法量化的手艺实现标准化，把技术能够实现的交给技术，让匠人更加专注于手艺本身。'},
                    {title:'不断突破·革新行业',desc:'细微到走线手法、喷枪姿势，包拯有上百条标准，并仍在每天不断革新。同时肩负行业领先者的使命，不断寻求新的工艺突破，变革这个千年不变的传统行业。'},
                    {title:'安全保障·全程监控',desc:'5000平修复中心，全域移动监控侦测覆盖无死角监控，一物一码线上全程数据记录，安全高效，科技让手艺更显温度。'},
                ],
                list:[
                    {title:'90天',desc1:'最多可达',desc2:'售后保障'},
                    {title:'监控侦测',desc1:'全域移动',desc2:'全程覆盖'},
                    {title:'12小时',desc1:'全天在线',desc2:'客服咨询'},
                    {title:'50万件',desc1:'已成功养护',desc2:'奢侈品'},
                ],
                swiperOption:{
                    slidesPerView:'auto',
                    spaceBetween:20,
                    slidesOffsetBefore:20,
                    // slidesOffsetAfter:20,
                },
                navActiveIndex:0,
                nav:[
                    {title:'箱包养护',pic:'brandDetail_10',content:'包包的材质一般为动物皮革，就像人的皮肤一样，细小的污渍剐蹭都会造成损伤，包拯为此而生。'},
                    {title:'短靴养护',pic:'brandDetail_11',content:'脏了的小白鞋、踢破的鞋头、沾水的鞋底、不舒服的高跟鞋……鞋子的问题，包拯都能解决！'},
                    {title:'衣裤养护',pic:'brandDetail_12',content:'不合身的衣裤、不小心划破的袖子、更有换季时间的皮衣发霉，包拯都可以帮你搞定！'},
                    {title:'饰品养护',pic:'brandDetail_13',content:'新皮带需要截短打孔，旧皮带边油脱落需要翻新，甚至毛绒玩具的洗澡，包拯都可以提供解决方案'},
                ]

            }
        },
        watch: {},
        computed: {},
        created() {
            window.scrollTo(0,0)
        },
        mounted() {
            publicObj.windowScrollAnimation.init('.animated');
            // wxShare({
            //     title:"包拯—我和明星都在追的包包护理品牌",
            //     desc:"打理心爱之物",
            //     imgUrl:this.SHARE_DEFAULT_IMG,
            //     link:window.location.href
            // })
        },
        methods: {
            //播放视频
            playVideo(){

                this.isPlay?
                    this.$refs.myVideo.pause()
                    :this.$refs.myVideo.play();
                this.isPlay = !this.isPlay
            },
            //导航选择
            checkNav(index){
                this.navActiveIndex = index
            }
        }

    }
</script>

<style scoped lang="scss">
.brandDetail{
    overflow: hidden;
    .show{opacity: 1!important;}
    /*顶部banner*/
    .banner{
        height: 1050px; position: relative;
        background: url("/images/base/brandDetail_01.png") no-repeat left top;
        background-size: 100%;
        .mask{
            position: absolute;left: 0;top:0;
            width: 100%;height: 100%;padding: 700px 0 0;box-sizing: border-box;
            img:first-of-type{width: 400px}
            img:last-of-type{width: 350px}
            .whiteLine{
                width: 300px;height: 5px;
                background: #fff;margin: 25px auto 35px;}
            background:linear-gradient(360deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.55) 100%)
        }
    }
    /*banner下信息列表*/
    .bannerBot{
        padding-left:20px;
        padding-right:20px;
        margin-top: 80px;
        li{opacity: .3;transition: .5s}
        h2{margin-bottom: 80px;font-size:40px;}
        .blackLine{
           height:4px;margin-bottom: 30px;background: #000;
        
        }
    }
    /*视频模块*/
    .videoWrap{
        position: relative;
        video,.videoMask{width:100%;height: 650px;margin-bottom: 40px}
        .videoMask{
            position:absolute;left:0;top:0;
            /*color: #fff;*/
            /*img{width: .51rem;margin-top: 1.65rem}*/
            /*p{line-height: .48rem}*/
            >div{
                width:100%;height: 650px;
                background: url("/images/base/brandDetail_02.png") no-repeat left top;
                background-size: 100%;
            }

        }
        .arrow{width:40px;margin-bottom:50px;}

        .videoBotList{
            // padding:.62rem .2rem .27rem;
            padding-left:20px;
            padding-bottom: 20px;
            padding-top:30px;
            
            li{margin-bottom: 80px;opacity: .3;transition: .5s}
            h2{line-height: 55px;margin-bottom: 40px;font-size:45px;}
            p{line-height: 50px;color: #797979;font-size:32px;}
        }


        .list{
            padding:80px 80px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            li{
                width: 35%;
                margin-bottom: 80px;
                opacity: .3;
                transition: .5s
            }
            h2{
                line-height: 70px;
                font-size: 50px;
            }
            p{
                line-height: 40px;
                color: #797979;
                font-size: 30px

            }
        }

    }

    /*关于*/
    .about{
        .aboutBanner{
            position: relative;
            .mask{
                width: 100%;height: 100%;padding: 80px 0 0 250px;box-sizing: border-box;
                position: absolute;
                left: 0;
                top: 0;
                background: rgba(0,0,0,.82);
                img{width: 300px}
                .whiteLine{
                    width:230px;
                    height:10px;
                    background:#fff;
                    margin-top:30px;
                    margin-bottom: 30px;
                }
                p{line-height: 45px;color: $white-color;font-size: 30px;}
            }
        }

        /*轮播导航*/
        .nav{
            padding-top: .32rem;
            .swiperSlide{width: 1.1rem;line-height: .3rem;transition: .2s;
                border-bottom: 2px $base-grey solid;color: $base-grey}
            .active{color: $primary-color;border-color: $primary-color}

        }
        .content{
            padding:30px 40px;
            line-height: .2rem;
            font-size: 30px;
            line-height: 45px;
            margin-bottom:80px;
            margin-top:100px; 
        }

        .imgArr{
            img:first-of-type{margin-bottom: 10px}
            .l,.r{width:49% }
        }
    }

    /*底部*/
    .bot{
        padding:80px 40px;
         
        h2{
            line-height: 70px;
            font-size:50px; 
        }
        p{
            margin-top: 20px;
            line-height: 50px;
            color: #797979;
            font-size:30px;
        }
        h2{
            margin-bottom: .1rem;
        }
    }

}
</style>

